import { Text, type TextProps } from "@/components/ui/text";
import { cn } from "@/lib/cn";

interface SectionHeaderProps {
  kicker?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  titleAs?: TextProps["as"];
}

function SectionHeader({
  kicker,
  title,
  subtitle,
  align = "left",
  titleAs = "h2",
}: SectionHeaderProps) {
  const centered = align === "center";

  return (
    <div className={cn("mb-10", centered && "text-center")}>
      {kicker && (
        <Text variant="cap" className="text-electric mb-3">
          {kicker}
        </Text>
      )}
      <Text as={titleAs} variant="display-l">
        {title}
      </Text>
      {subtitle && (
        <Text
          variant="body-l"
          className={cn("text-slate mt-3 max-w-[540px]", centered && "mx-auto")}
        >
          {subtitle}
        </Text>
      )}
    </div>
  );
}

export { SectionHeader, type SectionHeaderProps };
